import { render } from "./OidoCardHeader.vue?vue&type=template&id=3816ec8a&scoped=true"
import script from "./OidoCardHeader.vue?vue&type=script&lang=js"
export * from "./OidoCardHeader.vue?vue&type=script&lang=js"

import "./OidoCardHeader.vue?vue&type=style&index=0&id=3816ec8a&scoped=true&lang=css"
import "./OidoCardHeader.vue?vue&type=style&index=1&id=3816ec8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3816ec8a"]])

export default __exports__